<template>
    <div id="enCase">
               <div class="endowloadDetail-head">
             <img :src="list.pic" alt="" class="banner-img" ondragstart="return false;" oncontextmenu="return false;">
                  <div class="endowloadDetail-description">
                <div class="title">
                    <div class="title-txt">
                        <!-- {{list.name}} -->
                    </div>
                </div>
            </div>
               </div>
                  <div class="item-gradient">
            <div class="p-lg">
                <i class="icon-al-applicationgroup"></i>
                <h1>{{list.name}}</h1>
            </div>
        </div>
          <div class="endowloadDetail-contaniner" v-if="list.caseContentList.length" id="nr1" >
                 <div class="ace-dbl-nav-channel" :class="{ fixed: isFixed }">
              <div class="mod">
                <div class="inner flex align-cen">
                <div class="nav-text"
                 v-for="(item,index) in list.caseContentList"
                :key="index"
                :class="{ active: currentNav == index }"
                @click="toBox(index)"
                >{{item.title}}</div>
                </div>
                </div>
          </div>
           <div class="scene j-content" 
                      v-for="(item,index) in list.caseContentList"
                    :key="index"
             >
                  <div class="quedior">
                        <h2>{{item.title}}</h2>
                        <div class="subtitle ">{{item.subtitle}}</div>
                           <div v-html="item.content" class="nr" v-if="!$util.isMobile()"></div>
                        <div v-html="item.mobileContent ? item.mobileContent : item.content" class="nr" v-if="$util.isMobile()"></div>
                    </div>
             </div>
          </div>
              <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
                <span class="icon-al-wind-cry"></span>
                    <p>暂无数据</p>
                </div>
            <!-- <div class="endowloadDetail-contaniner">
              <div class="con-head">
                 <h1 class="name">{{list.name}}</h1>
                <div class="time">{{list.createTime}}</div>
              </div>
               <div class="qu-con">
                 <div v-html="list.content"></div>
               </div>
            </div> -->
            <!-- <div class="endowloadDetail-head" >
              <div class="bg-overlay">
                <h1 class="name">{{list.name}}</h1>
                <div class="time">{{list.createTime}}</div>
              </div>
             </div>
             <div class="qu-con">
              <div v-html="list.content"></div>
             </div> -->
         <!-- <div class="endowloadDetail-contaniner" v-if="list.solutionContentList && list.solutionContentList.length >0" id="nr1" >
          <div class="ace-dbl-nav-channel" :class="{ fixed: isFixed }">
              <div class="mod">
                <div class="inner flex align-cen">
                <div class="nav-text"
                 v-for="(item,index) in list.solutionContentList"
                :key="index"
                :class="{ active: currentNav == index }"
                @click="toBox(index)"
                >{{item.title}}</div>
                </div>
                </div>
          </div>
            <div class="scene j-content" 
                      v-for="(item,index) in list.solutionContentList"
                    :key="index"
             >
                  <div class="quedior">
                        <h2>{{item.title}}</h2>
                        <div class="subtitle ">{{item.subhead}}</div>
                        <div v-html="item.content" class="nr"></div>
                    </div>
             </div>
         </div>
            <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
            <span class="icon-al-wind-cry"></span>
            <p>暂无数据</p>
        </div> -->
        <goTop></goTop>
    </div>
</template>
<script>
import { caseDetail} from "@/api/enterprise/index" // 解决方案详情
import LocaStorage from "../../utils/localstorage.js"
import goTop from '@/components/goTop'
import debounce from '../../utils/debounce.js' //防抖
import "../../assets/styles/font.css";
export default {
    name:'enCasesDetail',
    data() {
        return {
            currentNav:0,
            list:{},
            tabPosition:'top',
            isFixed: false,
            isClick:false,
            lotoken:false,
            appGl:[],
            contentTopList:[],
        }
    },
    components:{
        goTop
    },
     mounted() {
        window.addEventListener('scroll', this.handleScroll) // 监听滑动事件
  },
    created () {
        this.lotoken = LocaStorage.setAge().get('token1') ? true : false
        this.getInfo()
    },
    methods: { 
                  // 点击tab
    toBox(index) {
    // 点击滚动到指定的位置，要去掉滚动的过程中因为位置变化带来的效果
      this.isClick = true
      this.currentNav = index
      const DOM = document.querySelectorAll('.j-content')[index]
      const offsetTop = DOM.offsetTop - 50
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
       // 过一段时间，把isClick还原
      setTimeout(() => {
        this.isClick = false
      }, 800)
    },
            // 处理滚动
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var offsetTop 
      offsetTop = document.querySelector('.banner-img').offsetHeight
    //   if(this.$route.query.type == 3) offsetTop = 0
       // 获取所有锚点元素
      const divs = [...document.querySelectorAll('.j-content')]
      // 将所有锚点元素offsetTop push到数组内
      divs.forEach((item, index) => {
        this.contentTopList[index] = item.offsetTop - 50
        
      })
       // 判断当前是否是点击定位的，如果不是，才有滚动定位的效果
      if (!this.isClick) {
        let navIndex
        // 滚动定位tab高亮的状态
        for (let i = 0; i < this.contentTopList.length; i++) {
          // 如果当前滚动的top坐标大于第i个的top坐标，就记录下i。记录到最后，i就会是最后一个满足条件的i，也就是刚刚好的那个值
          if (scrollTop >= this.contentTopList[i]) {
            navIndex = i
          }
        }
        // 把下标赋值给 vue 的 data
        console.log(navIndex)
        this.currentNav = navIndex
        if (typeof navIndex !== 'number') {
           this.currentNav = 0
        }
      }
      // 吸顶效果
        if (scrollTop > offsetTop) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
                  //防抖触发
        debounce(() => {
            this.$bus.$emit("fixedState",this.isFixed);
        }, 300)
         
    },
        // 获取详情
         getInfo(){
              caseDetail({
                id:this.$route.query.id,
            },'enterprise')
            .then(res => {
                if(res.code == 1) return this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
              res.code == 0 ?  this.list = res.data : this.list = {}
              document.title= res.data.name
                if(this.list){
                           this.$nextTick(function(){
                 const imgDomArray = document.getElementById('enCase')
             imgDomArray.setAttribute('ondragstart','return false')
             imgDomArray.setAttribute('oncontextmenu','return false')
              })
                }
            })
            .catch(err => {

            })
        },
    },
      destroyed() {
    window.removeEventListener('scroll', this.handleScroll) // 销毁监听滑动事件
  },
}
</script>
<style lang="scss" scoped>
#enCase{
    .item-gradient{
        display: none;
    }
          .banner-img{
            width: 100%;
            height: 396px;
            object-fit: cover;
            position: absolute;
            top: 0;
            left: 0;
        }
           .endowloadDetail-description{
         max-width: 1180px;
         margin: 0 auto;
        padding-top: 16px;
               min-height: 380px;
               position: relative;
               z-index: 1;
         .title{
             margin-top: 150px;
             font-size: 0;
             .title-txt{
                display: inline-block;
                vertical-align: middle;
                font-size: 36px;
                line-height: 48px;
                color: #323233;
             }
         }
           }
        .con-head{
          position: relative;
          text-align: center;
          padding:30px 0;
          .name{
            font-size: 32px;
            letter-spacing: 7px;
            margin-bottom: 0;
            text-shadow: 1px 1px 2px rgb(0 0 0 / 30%);
            color: inherit;
          }
          .time{
            color: #ccc;
          }
        }
        .endowloadDetail-head{
        position: relative;
        .bg-overlay{
          width: 1170px;
          margin: 0 auto;
          color: #fff;
          text-align: center;
          .name{
            font-size: 32px;
            letter-spacing: 7px;
            margin-bottom: 0;
            text-shadow: 1px 1px 2px rgb(0 0 0 / 30%);
            color: inherit;
          }
          .time{
            color: #ccc;
          }
        }
    }
    .endowloadDetail-contaniner{
      width: 100%;
      margin: 0 auto;
    }
}
@media (max-width: 640px){
  #enCase{
    margin-top: -56px;
    .banner-img{
      height: auto;
          position: relative;
    }
      .endowloadDetail-description{
        display: none;
    }
    .endowloadDetail-contaniner{
      width: 80%;
      margin: 0 auto;
    }
  }
     .item-gradient{
        padding: 10px;
          display: block !important;
          margin-top: 20px;
          
       .p-lg{
        background: #FAFAFA;
       border-radius: 10px;
        transition: all .3s;
        padding: 30px;
        text-align: center;
        border:1px solid  #D0D0D0;
        i{
            color: #000;
            font-size: 40px;
        }
       }
    }
  .qu-con{
width: 100% !important;
  }
}
::v-deep{
       .nr{
            p{
                img{margin: 0 auto !important;
                display: block;
                }
            }
        }
}
</style>